import React, { useEffect, useState } from "react";
import { Button } from "antd";
import "antd/dist/reset.css";
import Input from "../Input/Input";
//import FileUploadButton from "../../../../../../components/Elements/Buttons/UploadDocs/FileUploadButton";
import PhoneNumberInput from "../../../../../components/Elements/Input/PhoneNumberInput";
import { useSelector } from "react-redux";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
const ContactDetails = () => {
  const token = useSelector((state) => state.auth.authToken);
  const [contactDetails, setContactDetails] = useState({
    contactPersonName: "",
    copyOfPassport: "",
    contactNumber: {
      countryCode: "",
      phoneNumber: "",
    },
    otp: "",
    emailId: "",
  });

  const fetchDetails = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_KYC_DETAILS,
        token: token,
      });
      if (response.success) {
        const data = response.data;
        setContactDetails({
          contactPersonName:
            data.organization.orgBillingInfo.contactDetails.PersonName,
          copyOfPassport: data.organization.org_documents.goverment_issued_id,
          contactNumber: {
            countryCode:
              data.organization.orgBillingInfo.contactDetails.billing_mobile_no
                .PhoneCode,
            phoneNumber:
              data.organization.orgBillingInfo.contactDetails.billing_mobile_no
                .ContactNumber,
          },
          otp: "",
          emailId: data.organization.orgBillingInfo.contactDetails.contactEmail,
        });
      }
    } catch (error) {
      console.log("Unable to get data", error);
    }
  };

  const handleChange = (e) => {
    setContactDetails({
      ...contactDetails,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (token) {
      fetchDetails();
    }
  }, []);

  return (
    <div className="w-full bg-white py-4 px-4 sm:px-8 rounded-lg lg:px-16">
      {/* Contact Person Name */}
      <div className="mb-6">
        <label className="block font-semibold text-gray-600 mb-1">
          Contact Person Name
        </label>
        <Input
          type="text"
          name="contactPersonName"
          value={contactDetails.contactPersonName}
          onChange={handleChange}
          className="w-full max-w-md"
          variant="secondary"
        />
      </div>

      {/* Passport Upload Section */}
      <div className="mb-6 flex gap-4">
        <label className="block font-semibold text-gray-600 mb-2">
          A copy of Passport and government-issued identification (identity
          proof)
        </label>
        {contactDetails.copyOfPassport ? (
          <Button
            type="secondary"
            className="bg-[#0087A3] text-white text-xs w-20 h-7"
            onClick={() => window.open(contactDetails.copyOfPassport, "_blank")}
          >
            View
          </Button>
        ) : (
          <span className="text-red-500 text-sm">Not Available</span>
        )}
      </div>

      {/* Phone Number, OTP, Email */}
      {/* <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6 flex-wrap mb-6">
        <PhoneNumberInput
          disable={true}
          value={contactDetails.contactNumber}
          onChange={(updatedValue) =>
            setContactDetails((prev) => ({
              ...prev,
              contactNumber: updatedValue,
            }))
          }
        />

        <div className="text-[#06513D] border-2 border-[#06513D] px-4 py-2 text-sm rounded-full text-center cursor-pointer">
          Send Code
        </div>

        <Input
          type="text"
          name="otp"
          className="w-28"
          value={contactDetails.otp}
          onChange={handleChange}
          placeholder="OTP"
          variant="secondary"
        />

        <div className="text-[#06513D] border-2 border-[#06513D] px-4 py-2 text-sm rounded-full text-center cursor-pointer">
          Verify
        </div>

        <Input
          type="text"
          name="emailId"
          className="w-full md:w-64"
          value={contactDetails.emailId}
          onChange={handleChange}
          placeholder="Email-Id"
          variant="secondary"
        />
      </div> */}

      {/* Phone Number, OTP, and Email Section */}
      <div className="flex flex-col gap-6 md:flex-row md:items-center md:gap-6 flex-wrap mb-6">
        {/* Phone Number (Read-only) */}
        <PhoneNumberInput
          disable={true}
          value={contactDetails.contactNumber}
          onChange={(updatedValue) =>
            setContactDetails((prev) => ({
              ...prev,
              contactNumber: updatedValue,
            }))
          }
        />

        {/* OTP Input + Verify Button */}

        {/* Email Input + Send Code Button */}
        <div className="flex items-center gap-2 w-full md:w-auto">
          <Input
            type="text"
            name="emailId"
            className="w-full md:w-64"
            value={contactDetails.emailId}
            onChange={handleChange}
            placeholder="Email-Id"
            variant="secondary"
          />
          <div className="text-[#06513D] border-2 border-[#06513D] px-4 py-1.5 text-sm rounded-full cursor-pointer whitespace-nowrap">
            Send Code
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Input
            type="text"
            name="otp"
            className="w-28"
            value={contactDetails.otp}
            onChange={handleChange}
            placeholder="OTP"
            variant="secondary"
          />
          <div className="text-[#06513D] border-2 border-[#06513D] px-4 py-1.5 text-sm rounded-full cursor-pointer">
            Verify
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="text-center mt-8">
        <Button
          type="secondary"
          className="bg-[#06513D] text-white text-sm px-10 py-3"
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default ContactDetails;
